module.exports = __webpack_public_path__ + "static/media/disponivel-na-app-store.ad8630e3.png";